module.exports = __webpack_public_path__ + "img/CT.Bridges.Substructure.Column_Pier_(Precast).Reinforced_Concrete.3364a338.png";